// ** Third Party Components
import {Download, Edit} from 'react-feather'

// ** Table Common Column
export const columns = [
  {
    name: 'No Template',
    width: '20%',
    center: true,
    selector: row => row.noTemplate,
    sortable: true,
    cell: row => (
      <div className='d-flex align-items-center text-center'>
        {row.noTemplate}
      </div>
    )
  },
  {
    name: 'Nombre de plantilla',
    width: '30%',
    sortable: true,
    center: true,
    selector: row => row.templateName
  },
  {
    name: 'Fecha de Creacion',
    width: '30%',
    center: true,
    sortable: true,
    selector: row => row.createDate,
  },
  {
    name: 'Acciones',
    width: '20%',
    center: true,
    allowOverflow: true,
    cell: (row) => {
      return (
        <div className='d-flex'>
          <div className='pe-1 cursor-pointer'>
            <a href={row.urlDocument}
               download={'file'}>
              <Download size={20} />
            </a>
          </div>
          <div className='pe-1 cursor-pointer'>
            <a href={`/edit-template/${row.noTemplate}`}>
            <Edit size={20} />
            </a>
          </div>
        </div>
      )
    }
  }
]
